import { render, staticRenderFns } from "./SizeGuideTable.vue?vue&type=template&id=16131514&scoped=true&"
import script from "./SizeGuideTable.vue?vue&type=script&lang=ts&"
export * from "./SizeGuideTable.vue?vue&type=script&lang=ts&"
import style0 from "./SizeGuideTable.vue?vue&type=style&index=0&id=16131514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16131514",
  null
  
)

export default component.exports